import { BrandLogo } from "@/components/common/BrandLogo";
import { fmtDate } from "@/lib/format";
import { publicPdfUrl } from "./proposalUtils";

export const ProposalFooter = ({ data }) => {
  const c = data.company || {};
  const q = data.quote;
  return (
    <footer className="border-t border-border/70" data-testid="proposal-footer">
      <div className="mx-auto flex max-w-[1180px] flex-col justify-between gap-8 px-5 py-12 text-[13px] text-muted-foreground sm:flex-row sm:px-8">
        <div>
          <BrandLogo />
          <div className="mt-4 space-y-0.5">
            {c.address && <div>{c.address}</div>}
            {c.org_number && <div>Org.nr {c.org_number}</div>}
            <div className="flex flex-wrap gap-x-3">
              {c.phone && <a href={`tel:${String(c.phone).replace(/\s/g, "")}`} className="link" data-testid="proposal-footer-phone">{c.phone}</a>}
              {c.email && <a href={`mailto:${c.email}`} className="link" data-testid="proposal-footer-email">{c.email}</a>}
            </div>
          </div>
        </div>
        <div className="sm:text-right">
          <div className="font-mono tabular">{q.quote_number} · Versjon {q.version}</div>
          <div className="mt-1">Utarbeidet {fmtDate(q.created_at)}{q.sent_at ? ` · sendt ${fmtDate(q.sent_at)}` : ""}</div>
          <a href={publicPdfUrl(data.token)} target="_blank" rel="noopener noreferrer" className="link mt-2 inline-block" data-testid="proposal-footer-pdf-link">Last ned som PDF</a>
          <div className="mt-4 text-[12px] text-muted-foreground/70">© {new Date().getFullYear()} {c.name}. Tilbudet er konfidensielt og utarbeidet for {data.customer?.name}.</div>
        </div>
      </div>
    </footer>
  );
};
